import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'bookraw/shared/components/dialog/models/dialog-data.model';

@Component({
  selector: 'app-dialog',
  styleUrls: ['dialog.component.scss'],
  template: `
    <div mat-dialog-title *ngIf="data.titleTemplate">
      <ng-container
        [ngTemplateOutlet]="data.titleTemplate"
        [ngTemplateOutletContext]="data.context"
      ></ng-container>
    </div>
    <div mat-dialog-content>
      <p class="dialog-paragraph">{{ data.headerText }}</p>
      <ng-container
        [ngTemplateOutlet]="data.template"
        [ngTemplateOutletContext]="data.context"
      ></ng-container>
    </div>
  `
})
export class DialogComponent<T> {

  constructor(
    public dialogRef: MatDialogRef<DialogComponent<T>>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData
  ) { }
}
